import DateSelector from '../../1elements/Fields/DateSelector'
import {Text} from '../../1elements'
import makeStyles from '@material-ui/core/styles/makeStyles'
import FormHelperText from '@mui/material/FormHelperText'

const useStyles = makeStyles({
    root: {
        maxWidth: '160px'
    },
    dateSelector: {
        margin: 0,
        '& .MuiInputBase-input': {
            padding: '5px 0'
        }
    }
})

const SmartFormDatePicker = ({onChange, value, validation, disabled, label, required, disableFuture, disablePast}) => {
    const classes = useStyles()

    return(
        <div className={classes.root}>
            <Text type={'fieldLabel'}>{label}{required && <span className={'requiredAsterisk'}>*</span>}</Text>
            <DateSelector disableFuture={disableFuture} disablePast={disablePast} onChange={onChange} value={value}
                          className={classes.dateSelector} validation={validation} disabled={disabled}/>
            <FormHelperText error={Boolean(validation)}>{validation}</FormHelperText>
        </div>
    )
}

export default SmartFormDatePicker
